import { NavigationGuard, RouteConfig, Route } from 'vue-router';
import { RouteName } from '../routes.constants';
import {
    authenticationGuard,
    AuthRestriction,
    config,
    CorexUserRestriction,
    lightTopNavigation,
    modalGuard,
} from '../../services';
import { ModalSize } from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import { getHistoryRoute } from '../wallet/wallet.routes';

export const getSweepstakesComponent =
    (component: keyof typeof import('./sweepstakes.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "sweepstakes" */
            './sweepstakes.chunk'
        );
        return chunk[component];
    };

const coinShopGuard: NavigationGuard = (_, __, next) => {
    const isLoggedIn = !!magic.session.getUser();
    if (isLoggedIn && config.sweepstakes) {
        next();
    } else {
        next(false);
    }
};

export const SweepxRoutes: RouteConfig[] = [
    {
        name: RouteName.SWEEPSTAKES_SHOP,
        path: 'coin-shop/:promoSlug?',
        component: getSweepstakesComponent('SweepstakesBuyPage'),
        beforeEnter: coinShopGuard,
        meta: {
            ...lightTopNavigation('sweepstakes-shop.title'),
            ...authenticationGuard(AuthRestriction.AUTH_REQUIRED),
            ...modalGuard(
                getSweepstakesComponent('SweepstakesBuyPage'),
                'sweepstakes-shop.title',
                {
                    options: {
                        size: ModalSize.DEFAULT,
                    },
                    uniqueModalId: 'sweepx-wallet',
                    desktopOnly: (route: Route) =>
                        route.name !== RouteName.GAMEPLAY,
                },
            ),
            corexUserRestriction: CorexUserRestriction.SWEEPX_DEPOSIT,
        },
    },
    {
        name: RouteName.SWEEPSTAKES_REDEEM,
        path: 'redeem-coins',
        component: getSweepstakesComponent('SweepstakesRedeemPage'),
        beforeEnter: coinShopGuard,
        meta: {
            ...lightTopNavigation('sweepstakes-redeem.title'),
            ...authenticationGuard(AuthRestriction.AUTH_REQUIRED),
            ...modalGuard(
                getSweepstakesComponent('SweepstakesRedeemPage'),
                'sweepstakes-redeem.title',
                {
                    options: {
                        size: ModalSize.DEFAULT,
                    },
                    uniqueModalId: 'sweepx-wallet',
                    desktopOnly: (route: Route) =>
                        route.name !== RouteName.GAMEPLAY,
                },
            ),
            corexUserRestriction: CorexUserRestriction.SWEEPX_REDEEM,
        },
    },
    getHistoryRoute('wallet-navigation.history', {
        uniqueModalId: 'sweepx-wallet',
        options: {
            backArrow: false,
        },
        desktopOnly: (route: Route) => route.name !== RouteName.GAMEPLAY,
    }),
];
